<template>
  <ejs-richtexteditor v-if="create" :id="'rteObj' + randowId" locale="pt-BR" :ref="'rteObj' + randowId" :saveInterval="saveInterval" :autoSaveOnIdle="true" :change="onChange"
    :created="onCreate" :actionBegin="actionBeginEvent" :toolbarSettings="textToolExp ? toolbarSettingsExpanded : toolbarSettingsRetained"
    :insertImageSettings="imageSettingsModel" :height="height" :width="width" :pasteCleanupSettings="pasteCleanupModel" :fontFamily="fontFamily">
  </ejs-richtexteditor>
</template>

<style>
  @import "./../../../node_modules/@syncfusion/ej2-base/styles/material.css";
  @import "./../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
  @import "./../../../node_modules/@syncfusion/ej2-lists/styles/material.css";
  @import "./../../../node_modules/@syncfusion/ej2-popups/styles/material.css";
  @import "./../../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
  @import "./../../../node_modules/@syncfusion/ej2-navigations/styles/material.css";
  @import "./../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
  @import "./../../../node_modules/@syncfusion/ej2-vue-richtexteditor/styles/material.css";
  .illis_mention, .illis_document, .illis_automation {
    color: teal;
  }

  .avatar_user{
    background: #00acc2;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .e-rte-img-dialog {
    bottom:100px !important;
  }

  #editor img {
    width: 250px;
    cursor: zoom-in;
  }

  .idTextComment img {
    max-width: 350px;
    cursor: zoom-in;
  }
  .e-btn.e-flat.e-primary {
    color: #00acc2
  }
  .e-btn.e-flat.e-primary:hover {
    color: #00acc2
  }
  .e-btn.e-flat.e-primary {
    color: #00acc2
  }
  .e-btn.e-primary:hover {
    color: #00acc2
  }
  .e-btn.e-primary {
    color: #00acc2
  }

  .e-checkbox-wrapper:hover .e-frame.e-check, .e-css.e-checkbox-wrapper:hover .e-frame.e-check {
    color: #00acc2
  }

 .e-checkbox-wrapper:hover .e-frame.e-check, .e-css.e-checkbox-wrapper:hover .e-frame.e-check {
    color: #00acc2
  }

  .e-checkbox-wrapper:hover .e-frame.e-check, .e-css.e-checkbox-wrapper:hover .e-frame.e-check {
    background-color: #00acc2
  }

  .e-checkbox-wrapper:hover .e-frame.e-check, .e-css.e-checkbox-wrapper:hover .e-frame.e-check {
    background-color: #00acc2
  }

  .e-checkbox-wrapper .e-frame.e-check, .e-css.e-checkbox-wrapper .e-frame.e-check {
    border-color: #00acc2
  }

  .e-checkbox-wrapper:hover .e-frame.e-check, .e-css.e-checkbox-wrapper:hover .e-frame.e-check {
    background-color: #00acc2
  }

  .e-checkbox-wrapper .e-frame.e-check, .e-css.e-checkbox-wrapper .e-frame.e-check {
    background-color: #00acc2
  }
  input.e-input::selection, textarea.e-input::selection, .e-input-group input.e-input::selection, .e-input-group.e-control-wrapper input.e-input::selection, .e-float-input input::selection, .e-float-input.e-control-wrapper input::selection, .e-input-group textarea.e-input::selection, .e-input-group.e-control-wrapper textarea.e-input::selection, .e-float-input textarea::selection, .e-float-input.e-control-wrapper textarea::selection {
    color: #00acc2
  }
  .e-rte-table-popup.e-popup-open .e-rte-tablecell.e-active {
    background-color: #00acc2;
    border: 1px solid #105a64;
  }
  .e-toolbar-wrapper{
    min-height: 46px !important;
  }
  .e-rte-content{
    min-height: 294px !important;
  }

  .tribute-container {
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    max-height: 300px;
    max-width: 500px;
    min-width: 200px;
    overflow: auto;
    display: block;
    z-index: 999999;
    box-shadow: 0 5px 5px -3px rgb(0 0 0 / 20%), 0 8px 10px 1px rgb(0 0 0 / 14%), 0 3px 14px 2px rgb(0 0 0 / 12%) !important;
    background: rgb(255, 255, 255);
    font-family:Roboto,sans-serif;
  }
  .tribute-container ul {
    margin: 0;
    margin-top: 2px;
    padding: 0;
    list-style: none;
  }
  .tribute-container li {
    padding: 5px 5px;
    cursor: pointer;
  }
  /* Quando passa o mouse por cima */
  .tribute-container li.highlight {
    background: rgb(243, 243, 243);
    font-family:Roboto,sans-serif;
  }
</style>

<script>
  /* eslint-disable no-unused-expressions */
  import imageCompress from '../../mixin/imageCompress'
  import { L10n } from '@syncfusion/ej2-base'
  import { Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar, Table, PasteCleanup } from '@syncfusion/ej2-vue-richtexteditor'
  import Tribute from 'tributejs'
  import plan from './../../mixin/plan'
  import general from './../../mixin/general'

  export default {
    mixins: [imageCompress, plan, general],
    provide: {
      richtexteditor: [Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar, Table, PasteCleanup]
    },
    props: {
      // saveInterval in milliseconds for autosave the value. The change event will be triggered if the content was changed from the last saved interval.
      saveInterval: {
        type: Number,
        default: 10000 // Defaults to 10000
      },
      imageSettingsModel: {
        type: Object,
        default: () => { return {saveFormat: 'Blob'} }
      },
      height: {
        default: '100%'
      },
      width: {
        default: '100%'
      }
    },
    data: () => ({
      create: false,
      textToolExp: false,
      tribute: null,
      basePath: process.env.API,
      // Cria um id random para não dar conflito caso tenha mais de um ptexteditor
      randowId: Math.floor(Math.random() * (10000 - 1)) + 1,
      backgroundColor: {
        colorCode: '#00acc2',
        default: '#00acc2'
      },
      toolbarSettingsExpanded: {},
      toolbarSettingsRetained: {},
      fontFamily: {
        default: 'arial'
      },
      pasteCleanupModel: {
        keepFormat: false
      },
      return: {
        showCharCount: true,
        myCodeMirror: '',
        maxLength: 2000
      }
    }),
    created () {
      // this.toolbarSettingsExpanded = {
      //   type: 'Expand',
      //   items: ['Bold', 'Italic', 'Underline',
      //     'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|', 'Image', 'CreateTable', '|',
      //     'Alignments', 'OrderedList', 'UnorderedList',
      //     'Outdent', 'Indent', '|', 'StrikeThrough',
      //     'LowerCase', 'UpperCase'
      //   ]
      // }
      // enableFloating usado pois no mobile o toobar  estava ficando pro cima do texto
      this.toolbarSettingsExpanded = {
        enableFloating: false,
        type: 'MultiRow',
        items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
          'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
          'LowerCase', 'UpperCase', '|', 'CreateTable', '|',
          'Alignments', 'OrderedList', 'UnorderedList',
          'Outdent', 'Indent', '|',
          'CreateLink', 'Image', '|', 'Print', '|', 'Undo', 'Redo', {
            tooltipText: 'Retrair',
            template: '<a class="e-tbar-btn e-btn" tabindex="-1" id="custom_tbar_retain' + this.randowId + '"  style="width:100%"><div class="e-tbar-btn-text" style="font-weight: 500;">-</div></a>'
          }
        ]
      }
      this.toolbarSettingsRetained = {
        enableFloating: false,
        type: 'MultiRow',
        items: ['Bold', 'Italic', 'Underline',
          'FontColor', 'BackgroundColor',
          '|',
          'Alignments', 'OrderedList', 'UnorderedList', '|', 'CreateTable', '|',
          'Image',
          '|', {
            tooltipText: 'Expandir',
            template: '<a class="e-tbar-btn e-btn" tabindex="-1" id="custom_tbar_expand' + this.randowId + '"  style="width:100%"><div class="e-tbar-btn-text" style="font-weight: 500;">+</div></a>'
          }
        ]
      }
      this.create = true
    },
    methods: {
      getRandowId () {
        return this.randowId
      },
      focus (time = 200) {
        setTimeout(() => {
          this.$refs['rteObj' + this.randowId].ej2Instances.inputElement.focus()
        }, time)
      },
      getValue () {
        return this.$refs['rteObj' + this.randowId].ej2Instances.getHtml()
      },
      getValueText () {
        return this.$refs['rteObj' + this.randowId].ej2Instances.getText()
      },
      setValue (value) {
        this.$refs['rteObj' + this.randowId].ej2Instances.value = value
      },
      refresh (time = 200) {
        setTimeout(() => {
          this.$refs['rteObj' + this.randowId].ej2Instances.refreshUI()
          // this.$refs['rteObj' + this.randowId].ej2Instances.inputElement.focus()
        }, time)
      },
      onChange () {
        this.$emit('change', this.$refs['rteObj' + this.randowId].ej2Instances.getHtml())
      },
      onCreate (e) {
        var customBtnR = document.getElementById('custom_tbar_retain' + this.randowId)
        var customBtnE = document.getElementById('custom_tbar_expand' + this.randowId)
        if (customBtnR) {
          customBtnR.onclick = (e) => {
            this.textToolExp = false
            setTimeout((e) => { this.onCreate() }, 100)
          }
        }
        if (customBtnE) {
          customBtnE.onclick = (e) => {
            this.textToolExp = true
            setTimeout((e) => { this.onCreate() }, 100)
          }
        }
      },
      // função criada para dar inicio as menções
      createMention (usersTask) {
        if (this.tribute !== null) {
          this.tribute.detach(this.$refs['rteObj' + this.randowId].ej2Instances.inputElement)
        }
        this.tribute = new Tribute({
          values: usersTask,
          // column to search against in the object (accepts function or string)
          lookup: 'id_text',
          // column that contains the content to insert by default
          fillAttr: 'id_text',
          noMatchTemplate: `<a class="v-list__tile v-list__tile--link theme--light" style="height: 35px;padding-left:10px;padding-right:5px"><div class="v-list__tile__content"><div class="v-list__tile__title">Usuário não encontrado na tarefa</div></div></a>`,
          selectTemplate: (item) => {
            return '<span class="illis_mention" user_id=' + item.original.id + ' contenteditable="false">@' + item.original.id_text + '</span>'
          },
          menuItemTemplate: (item) => {
            if (item.original.photo_path) {
              return `<a class="v-list__tile v-list__tile--link theme--light" style="height: 35px;padding-left:10px;padding-right:5px"><div class="v-avatar" style="height: 30px; width: 30px; padding-right:15px"><div><img dark="" src="${this.basePath}uploads/users/${item.original.photo_path}" alt="avatar" style="height: 30px; width: 30px;"></div></div> <div class="v-list__tile__content"><div class="v-list__tile__title">${item.original.id_text}</div></div></a>`
            } else {
              return `<a class="v-list__tile v-list__tile--link theme--light" style="height: 35px;padding-left:10px;padding-right:5px"><div class="v-avatar" style="height: 30px; width: 30px; padding-right:15px;"><div><div dark="" class="avatar_user teal_border"><h3>${this.getFirstLetters(item.original.id_text)}</h3></div></div></div> <div class="v-list__tile__content"><div class="v-list__tile__title">${item.original.id_text}</div></div></a>`
            }
          }
        })
        this.tribute.attach(this.$refs['rteObj' + this.randowId].ej2Instances.inputElement)
      },
      // função criada para dar inicio a documentação personalizada
      createDocument (fields) {
        if (this.tribute !== null) {
          this.tribute.detach(this.$refs['rteObj' + this.randowId].ej2Instances.inputElement)
        }
        this.tribute = new Tribute({
          values: fields,
          // column to search against in the object (accepts function or string)
          lookup: 'filterText',
          // column that contains the content to insert by default
          fillAttr: 'title',
          noMatchTemplate: `<a class="v-list__tile v-list__tile--link theme--light" style="height: 35px;padding-left:10px;padding-right:5px"><div class="v-list__tile__content"><div class="v-list__tile__title">Campo não encontrado</div></div></a>`,
          selectTemplate: (item) => {
            return `<illis_document class="illis_document" field=${item.original.id} category=${item.original.category} type=${item.original.type} contenteditable="false">@${item.original.title} (${item.original.categoryText})</illis_document>`
          },
          menuItemTemplate: (item) => {
            return `<a class="v-list__tile v-list__tile--link theme--light" style="height: 35px;padding-left:10px;padding-right:5px"><div class="v-avatar" style="height: 30px; width: 30px; padding-right:15px;"><div><div dark="" class="avatar_user teal_border"><h3>${item.original.category === 'field_client' ? 'C' : (item.original.category === 'custom_field' ? 'CP' : (item.original.category === 'other_field' ? 'O' : 'T'))}</h3></div></div></div> <div class="v-list__tile__content"><div class="v-list__tile__title">${item.original.title}</div><div class="v-list__tile__sub-title" style="color:grey">${item.original.categoryText}</div></div></a>`
          }
        })
        let varr = 'rteObj' + this.randowId + '_rte-edit-view'
        var element = document.getElementById(varr)
        this.tribute.attach(element)
      },
      actionBeginEvent (args) {
        if (args.requestType === 'EnterAction') {
          args.cancel = true
        }
      }
    }
  }
  L10n.load({
    'pt-BR': {
      'richtexteditor': {
        'alignments': 'Alinhamentos',
        'justifyLeft': 'Justificar a Esquerda',
        'justifyCenter': 'Justificar Centro',
        'justifyRight': 'Justificar a Direita',
        'justifyFull': 'Justificar',
        'fontName': 'Nome da Fonte',
        'fontSize': 'Tamanho da Fonte',
        'fontColor': 'Cor da Fonte',
        'backgroundColor': 'Cor de fundo',
        'bold': 'Negrito',
        'italic': 'Italico',
        'underline': 'Sublinhar',
        'strikethrough': 'Riscar',
        'clearAll': 'Limpar',
        'clearFormat': 'Desformatar',
        'cut': 'Recortar',
        'copy': 'Colar',
        'paste': 'Colar',
        'unorderedList': 'Lista Desordenada',
        'orderedList': 'Lista Ordenada',
        'indent': 'Identar',
        'outdent': 'Desidentar',
        'undo': 'Desfazer',
        'redo': 'Refazer',
        'superscript': 'Posição',
        'subscript': 'Índice',
        'createLink': 'Criar Link',
        'removeLink': 'Remover Link',
        'openLink': 'Abrir Link',
        'editLink': 'Editar Link',
        'image': 'Imagem',
        'replace': 'Substituir',
        'align': 'Alinhar',
        'caption': 'Legenda',
        'formats': 'Formatos',
        'remove': 'Remover',
        'insertLink': 'inserir Link',
        'display': 'Exibir',
        'alttext': 'Texto Alternativo',
        'dimension': 'Dimensões',
        'fullscreen': 'Tela Cheia',
        'maximize': 'Maximizar',
        'minimize': 'Minimizar',
        'zoomIn': 'Aumentar Zoom',
        'zoomOut': 'Diminuir Zoom',
        'upperCase': 'Caixa Alta',
        'lowerCase': 'Caixa Baixa',
        'print': 'Imprimir',
        'sourcecode': 'Codigo Fonte',
        'preview': 'Visualização',
        'viewside': 'Mostrar Página',
        'insertcode': 'Inserir Código',
        'linkText': 'Texto do link',
        'linkTooltipLabel': 'Dica Flutuante',
        'linkWebUrl': 'Link para página externa',
        'linkOpenInNewWindow': 'Abrir link em nova pagina',
        'linkHeader': 'Link Externo',
        'dialogInsert': 'Inserir',
        'dialogCancel': 'Cancelar',
        'dialogUpdate': 'Atualizar',
        'imageHeader': 'Inserção de imagem',
        'imageLinkHeader': '',
        'imageUploadMessage': 'Arrastar',
        'imageDeviceUploadMessage': 'Upload',
        'imageAlternateText': 'Texto Alternativo',
        'alternateHeader': 'Texto Alternativo',
        'browse': 'Upload',
        'imageUrl': 'URL',
        'imageCaption': 'legenda',
        'imageSizeHeader': 'Tamanho',
        'imageHeight': 'Altura',
        'imageWidth': 'Largura',
        'textPlaceholder': 'Inserir Texto',
        'inserttablebtn': 'Inserir Tabela',
        'tabledialogHeader': 'Inserir Tabela',
        'tableWidth': 'Largura',
        'cellpadding': 'Preenchimento da Célula',
        'cellspacing': 'Espaçamento da Célula',
        'columns': 'Número de Colunas',
        'rows': 'Número de Linhas',
        'tableRows': 'Linhas da Tabela',
        'tableColumns': 'Colunas da Tabela',
        'tableCellHorizontalAlign': 'Alinhamento horizontal da Tabela',
        'tableCellVerticalAlign': 'Alinhamento Vertical da Tabela',
        'createTable': 'Criar Tabela',
        'removeTable': 'Remover Tabela',
        'tableHeader': 'Cabeçalho da tabela',
        'tableRemove': 'Remover Tabela',
        'tableCellBackground': 'Fundo de célula da tabela',
        'tableEditProperties': 'Propriedades de Edição da Tabela',
        'styles': 'Estilos',
        'insertColumnLeft': 'Inserir Coluna a Esquerda',
        'insertColumnRight': 'Inserir Coluna a Direita',
        'deleteColumn': 'Deletar Coluna',
        'insertRowBefore': 'Inserir Linha Embaixo',
        'insertRowAfter': 'Inserir Linha Acima',
        'deleteRow': 'Deletar Linha',
        'tableEditHeader': 'Edição de Tabela',
        'TableHeadingText': 'Tabela',
        'TableColText': 'Col',
        'imageInsertLinkHeader': 'Inserção Link na Imagem',
        'editImageHeader': 'Edição de Imagem',
        'alignmentsDropDownLeft': 'Esquerda',
        'alignmentsDropDownCenter': 'Centro',
        'alignmentsDropDownRight': 'Direita',
        'alignmentsDropDownJustify': 'Justificar',
        'imageDisplayDropDownInline': 'Na linha',
        'imageDisplayDropDownBreak': 'Quebrar Linha',
        'tableInsertRowDropDownBefore': 'Inserir Linha Acima',
        'tableInsertRowDropDownAfter': 'Inserir Linha Abaixo',
        'tableInsertRowDropDownDelete': 'Deletar Linha',
        'tableInsertColumnDropDownLeft': 'Inserir Coluna a Esquerda',
        'tableInsertColumnDropDownRight': 'Inserir Coluna a Direita',
        'tableInsertColumnDropDownDelete': 'Deletar Coluna',
        'tableVerticalAlignDropDownTop': 'Alinhar ao Topo',
        'tableVerticalAlignDropDownMiddle': 'Alinhar ao Meio',
        'tableVerticalAlignDropDownBottom': 'Alinhar ao Fundo',
        'tableStylesDropDownDashedBorder': 'Sublinhado',
        'tableStylesDropDownAlternateRows': 'Linhas alternativas',
        'pasteFormat': '',
        'pasteFormatContent': '',
        'plainText': '',
        'cleanFormat': '',
        'keepFormat': ''
      }
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/shared/PTextEditor.vue